const aboutPageData = {
  about_us_section: {
    title: "About Us",
    subtitle: "Your trusted partner in driving digital growth and innovation  ",
    description:
      "Empowering Businesses with AI-Driven Innovation & Smart Solutions  ",
  },
  vision_mission_section: {
    vision: {
      title: "Vision",
      text: "To be the most trusted partner for AI-powered business transformation in India and across the globe. ",
      imageSrc: "/vision.png",
      imageAlt: "Vision",
    },
    mission: {
      title: "Mission",
      text: "To empower businesses with intelligent, scalable, and result-oriented digital and technology solutions that drive growth, efficiency, and transformation.",
      imageSrc: "/mission.png",
      imageAlt: "Mission",
    },
  },
  who_we_are: {
    title: "",
    description: "",
  },
  what_makes_us_unique: {
    title: "What Makes Us Unique ?",
    points: [
      {
        color: "green",
        text: "<strong>Tailored Strategies:</strong> No templates. Only custom digital plans that suit your business.",
      },
      {
        color: "blue",
        text: "<strong>Data-Driven Campaigns:</strong> We turn insights into action for ROI-focused marketing.",
      },
      {
        color: "blue",
        text: "<strong>Tech-Enabled Execution:</strong> From automation to analytics, we stay ahead with technology.",
      },
      {
        color: "blue",
        text: "<strong>Client-Centric Approach:</strong> Fast, transparent, and always aligned with your goals.",
      },
    ],
  },
  core_services: {
    title: "Our Core Services",
    description:
      "We provide a 360° digital  ecosystem to help your business dominate online:",
    points: {
      leftData: [
        {
          text: "Web Development",
        },
        {
          text: "App Development",
        },
        {
          text: "Staffing (India & US)",
        },
        {
          text: "SEO",
        },
      ],
      rightData: [
        {
          text: "Digital Marketing",
        },
        {
          text: "SMS & WhatsApp API solutions",
        },
        {
          text: "Video & Display Advertising",
        },
        {
          text: " Lead Generation & SEM",
        },
      ],
    },
    image: {
      src: "/our-core-services.png",
      alt: "Our core services",
    },
  },
  impact_section: {
    title: "Our Numbers Shows Our Impact",
    statBars: [
      { value: 70, text: "Digital Projects" },
      { value: 40, text: "Organic Traffic Growth" },
      { value: 60, text: "10x Return on Ad Investment" },
      { value: 80, text: "Customer Engagement" },
    ],
    statNumbers: [
      { value: "100+", label: "Successful Digital Projects" },
      { value: "300 %", label: "Organic Traffic Growth" },
      { value: "10x", label: "Return on Ad Investment" },
      { value: "50 %", label: "Increase in Customer Engagement" },
    ],
  },
  who_we_serve: {
    title: "Specialized Expertise in Key Industries",
    description: "",
    industries: [
      {
        title: "Healthcare",

        alt: "Healthcare Industries Social Media Images",
      },
      {
        title: "Real Estate",

        alt: "Real Estate Industries Strategies",
      },
      {
        title: "Education",

        alt: "Social Media Creatives for Education",
      },
      {
        title: "E-Commerce",

        alt: "E-Commerce business solutions",
      },
      {
        title: "Retail",

        alt: "Digital marketing services for retails",
      },
      {
        title: "Travel & Hospitality",

        alt: "Digital marketing services for Travel & Hospitality",
      },
    ],
  },
  who_we_serve_home: {
    title: "Industry-Focused Solutions, Backed by Expertise",
    description: "",
    industries: [
      {
        title: "Healthcare",
        src: "/who-serve-1.png",
        alt: "Healthcare Industries Social Media Images",
      },
      {
        title: "Real Estate",
        src: "/who-serve-5.png",
        alt: "Real Estate Industries Strategies",
      },
      {
        title: "Education",
        src: "/who-serve-3.png",
        alt: "Social Media Creatives for Education",
      },
      {
        title: "E-Commerce",
        src: "/who-serve-4.png",
        alt: "E-Commerce business solutions",
      },
      {
        title: "Retail",
        src: "/who-serve-2.png",
        alt: "Digital marketing services for retails",
      },
      {
        title: "Travel & Hospitality",
        src: "/who-serve-6.png",
        alt: "Digital marketing services for Travel & Hospitality",
      },
    ],
  },
};

export default aboutPageData;
